const dict = {
    "home": ["Home"],
    "pinene": ["Home"],
    "express": ["Home"],
    "solution": ["Home", "Human Practices"],
    "attributions": ["Attributions"],
    "sponsor": ["Attributions"],
    "sponsors": ["Attributions"],
    "advisor": ["Attributions"],
    "advisors": ["Attributions"],
    "stakeholders": ["Attributions"],
    "collaborations": ["Collaborations"],
    "teams": ["Collaborations"],
    "jamboree": ["Collaborations"],
    "julygem": ["Collaborations"],
    "collaboration": ["Collaborations"],
    "igem": ["Collaborations"],
    "collaborate": ["Collaborations"],
    "communication": ["Communication"],
    "education": ["Communication", "Collaborations"],
    "shad": ["Communication"],
    "workshop": ["Communication"],
    "outreach": ["Communication"],
    "instagram": ["Communication"],
    "social": ["Communication"],
    "contribution": ["Contribution"],
    "procedure": ["Contribution", "Proof of Concept"],
    "gibson": ["Contribution"],
    "assembly": ["Contribution"],
    "troubleshooting": ["Contribution", "Engineering"],
    "description": ["Description"],
    "promotional": ["Description"],
    "video": ["Description"],
    "inspiration": ["Description"],
    "inspirations": ["Description"],
    "project": ["Description"],
    "goal": ["Description"],
    "engineering": ["Engineering"],
    "cycle": ["Engineering"],
    "build": ["Engineering"],
    "test": ["Engineering"],
    "learn": ["Engineering"],
    "metabolic": ["Engineering", "Model"],
    "pathway": ["Engineering", "Model"],
    "engineer": ["Engineering"],
    "plasmid": ["Engineering"],
    "construction": ["Engineering"],
    "human": ["Human Practices", "Members"],
    "practices": ["Human Practices", "Members"],
    "problem": ["Human Practices"],
    "environment": ["Human Practices"],
    "integrated": ["Human Practices"],
    "stakeholder": ["Human Practices", "Attributions"],
    "implementation": ["Implementation"],
    "manufacturing": ["Implementation", "Human Practices"],
    "process": ["Implementation"],
    "challenges": ["Implementation"],
    "members": ["Members", "Attributions"],
    "team": ["Members", "Attributions", "Collaborations"],
    "lab": ["Members"],
    "design": ["Members", "Engineering"],
    "math": ["Members"],
    "wiki": ["Members"],
    "finance": ["Members"],
    "member": ["Members", "Attributions"],
    "model": ["Model", "Engineering"],
    "assumptions": ["Model"],
    "analysis": ["Model"],
    "results": ["Model", "Proof of Concept"],
    "modelling": ["Model", "Engineering", "Members"],
    "bioreactor": ["Model", "Engineering"],
    "parts": ["Parts"],
    "biobicks": ["Parts"],
    "part": ["Parts", "Contribution"],
    "registry": ["Parts"],
    "proof": ["Proof of Concept"],
    "concept": ["Proof of Concept"],
    "methods": ["Proof of Concept"],
    "protocols": ["Proof of Concept"],
    "materials": ["Proof of Concept"],
    "transport": ["Proof of Concept"],
    "quantification": ["Proof of Concept"],
    "summary": ["Proof of Concept"],
    "framework": ["Proof of Concept"],
    "achievement": ["Proof of Concept", "Contribution"],
}

export default dict